// @ts-ignore - @phx/ads-api has no types
import Api from '@phx/ads-api';

export interface ApiResponse<T = any> {
  code: number;
  data: T;
  msg?: string;
}

interface ApiInstance {
  get<T = any>(url: string, params?: Record<string, any>): Promise<ApiResponse<T>>;
  post<T = any>(url: string, data?: Record<string, any>): Promise<ApiResponse<T>>;
}

const api: ApiInstance = new Api({
  apiPrefix: '',
  // devHost: 'http://localhost:3000',
  devHost: 'https://gray-writer.phoenix-music.com',
});

export default api;
